import { useEffect } from 'react';

import { InviteCard } from 'pages/dashboard/components/pending_invites_modal/components';
import { PendingPartnerInvite, UsersApi } from 'apis/UsersApi';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { useSuperState } from 'hooks';

export const PendingInvitesModal = () => {

    const [state, setState, resetState] = useSuperState({
        invites: [] as PendingPartnerInvite[],
        respondingId: null as number,
        visible: false
    });
    const { invites, respondingId, visible } = state;

    const hide = () => resetState();

    const fetchInvites = async () => {

        try {

            const invites = await UsersApi.GetPendingPartnerInvites();

            if (invites?.length > 0) setState({ invites, visible: true });

        } catch {

            // Silently fail — don't block the dashboard

        }

    };

    const respond = async (invite: PendingPartnerInvite, statusId: number) => {

        setState({ respondingId: invite.invitationId });

        try {

            await UsersApi.RespondToPartnerInvite(invite.invitationId, invite.partnerId, statusId);

            const remaining = invites.filter(i => i.invitationId !== invite.invitationId);

            if (remaining.length === 0) {

                // All invites handled — reload to refresh partner list
                window.location.reload();
                return;

            }

            setState({ invites: remaining, respondingId: null });

        } catch {

            setState({ respondingId: null });

        }

    };

    useEffect(() => {

        fetchInvites();

    }, []);

    return (
        <Modal centered backdrop={'static'} onHide={hide} show={visible} size={'lg'}>
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center gap-2">
                    <span>
                        <FormattedMessage defaultMessage="Pending Invitations" id="pending_invitations.d25a9229" />
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-3">
                    <FormattedMessage defaultMessage="You have been invited to join the following partners. Accept to gain access or decline to dismiss." id="you_have_been_invited_to_join_the_follow.a0f935e6" />
                </p>
                <div className="d-flex flex-column gap-2">
                    {invites.map(invite => (
                        <InviteCard
                            disabled={respondingId === invite.invitationId}
                            invite={invite}
                            key={invite.invitationId}
                            onRespond={respond}
                        />
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );

};
